var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.labelShowInlineStyle,
    attrs: {
      "data-test": "raft-autocomplete-wrapper"
    }
  }, [_vm._t("border", function () {
    return [_c('v-border-style', {
      attrs: {
        "status": _vm.borderStatus
      }
    })];
  }), _vm._v(" "), _vm._t("radiogroup"), _vm._v(" "), _vm.showLabel ? _c('label', {
    class: _vm.fieldLabelClasses,
    attrs: {
      "for": _vm.elementId,
      "id": _vm.elementId + '-label'
    }
  }, [_vm._v(_vm._s(_vm.label) + ": "), _vm.fieldRequired ? _c('sup', [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "autocomplete",
    attrs: {
      "id": _vm.elementId,
      "aria-owns": _vm.resultsElementId,
      "role": "combobox",
      "aria-haspopup": "listbox",
      "aria-expanded": _vm.showResults
    }
  }, [_vm._t("input"), _vm._v(" "), _c('div', {
    staticClass: "search-input-row"
  }, [_c('div', {
    staticClass: "autocomplete__box",
    class: {
      autocomplete__searching: _vm.showResults,
      invalid: _vm.invalidBorder
    }
  }, [_c('div', {
    staticClass: "autocomplete__inputs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.display,
      expression: "display"
    }],
    class: _vm.inputClass,
    attrs: {
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "maxlength": _vm.maxlength,
      "name": _vm.elementId,
      "required": _vm.fieldRequired,
      "type": "text",
      "autocomplete": "off",
      "role": "searchbox",
      "aria-autocomplete": "list",
      "aria-controls": _vm.resultsElementId,
      "aria-activedescendant": _vm.activeDescendant,
      "aria-labelledby": _vm.elementId + '-label'
    },
    domProps: {
      "value": _vm.display
    },
    on: {
      "click": _vm.search,
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.display = $event.target.value;
      }, _vm.search],
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.enter.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) return null;
        return _vm.close.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) return null;
        return _vm.up.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) return null;
        return _vm.down.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }],
      "focus": _vm.focus,
      "blur": _vm.blur
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "name": _vm.name,
      "type": "hidden"
    },
    domProps: {
      "value": _vm.value
    }
  })])]), _vm._v(" "), _vm.value || _vm.display ? _c('filter-clear-button', {
    on: {
      "click": _vm.resetAutocomplete
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('span', [_vm._t("helptext")], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showResults && !_vm.hideResults,
      expression: "showResults && !hideResults"
    }],
    class: _vm.resultsShowInlineStyle,
    style: _vm.listStyle,
    attrs: {
      "id": _vm.resultsElementId,
      "role": "listbox",
      "aria-label": "Autocomplete Results"
    }
  }, [_vm._t("results", function () {
    return [[_vm._t("firstResult"), _vm._v(" "), _vm._l(_vm.results, function (result, index) {
      return [_c('li', {
        key: 'li' + '-' + result[_vm.resultsValue || 'id'] + '-' + index
      }, [_c('label', {
        key: 'label-' + result[_vm.resultsValue || 'id']
      }, [_c('input', {
        key: 'radio-' + result[_vm.resultsValue || 'id'],
        staticClass: "autocomplete__results__item",
        class: {
          autocomplete__selected: _vm.isSelected(index)
        },
        attrs: {
          "type": "radio",
          "aria-selected": _vm.isSelected(index),
          "id": _vm.getId(index)
        },
        domProps: {
          "checked": _vm.isSelected(index)
        },
        on: {
          "click": function ($event) {
            return _vm.selectAndClose(result);
          }
        }
      }), _vm._v("\n                " + _vm._s(_vm.formatDisplay(result) || result.text) + "\n              ")])])];
    }), _vm._v(" "), _vm._t("lastResult")], _vm._v(" "), _vm.noResultMessage ? _c('li', {
      staticClass: "autocomplete__results__item autocomplete__no-results"
    }, [_vm._t("noResults", function () {
      return [_vm._v(" No Results. ")];
    })], 2) : _vm._e()];
  })], 2)], 2), _vm._v(" "), _vm.hasError ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n    " + _vm._s(_vm.error) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm._t("action")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }